import {HOST} from "./constants";
import axios, {AxiosInstance} from "axios/index";
import {app, auth} from "../utils/firebase";

export const axiosClient = async () =>
    new Promise<AxiosInstance>((resolve, reject) =>
        auth?.onAuthStateChanged(async value => {
            if (!value)
                localStorage.removeItem("impactCarCurrentUser")
            else
                resolve(axios.create({
                    baseURL: HOST,
                    headers: {
                        Authorization: await value.getIdToken(),
                    }
                }))
        }))